import { render, staticRenderFns } from "./tabRailwayBookingUICustomLayout.vue?vue&type=template&id=53a26fce&"
import script from "./tabRailwayBookingUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabRailwayBookingUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a26fce')) {
      api.createRecord('53a26fce', component.options)
    } else {
      api.reload('53a26fce', component.options)
    }
    module.hot.accept("./tabRailwayBookingUICustomLayout.vue?vue&type=template&id=53a26fce&", function () {
      api.rerender('53a26fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabRailwayBookingUICustomLayout.vue"
export default component.exports